import React, { type ReactNode } from 'react';
import { logError } from '../../services/errorReporting';
import ErrorPage from './ErrorPage';

interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  eventId?: string;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, eventId: '' };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    const eventId = logError(new Error('Crash', { cause: error }), { reactErrorInfo: errorInfo });

    console.error('Crash logged to Sentry #', eventId, error, errorInfo);
    this.setState({ eventId });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorPage eventId={this.state.eventId} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
